import { useSLAs } from "@/modules/towermanagement/pages/sla/useSlas";
import { useCustomersSuppliers } from "../../../modules/financial/pages/customersSuppliers/useCustomersSuppliers";
import { useUsers } from "../../../modules/global/pages/users/useUsers";
import { useApprovalFlowSteps } from "../../../modules/towermanagement/pages/approvalFlowSteps/useApprovalFlowSteps";
import { useApprovalFlowExecutionSteps } from "../../../modules/towermanagement/pages/steps/useApprovalFlowSteps";
import { useCustomers } from "../../../modules/towermanagement/pages/customer/useCustomers";
import { useOutsourcedes } from "../../../modules/towermanagement/pages/outsourcedes/useOutsourcedes";
import { usePlanningsMaintenances } from "../../../modules/towermanagement/pages/planningsMaintenances/usePlanningsMaintenances";
import { useReasons } from "../../../modules/towermanagement/pages/reasons/useReasons";
import { useOccurrenceTypes } from "../../../modules/towermanagement/pages/occurrenceTypes/useOccurrenceTypes";
import { useRegions } from "../../../modules/towermanagement/pages/regions/useRegions";
import { useScopes } from "../../../modules/towermanagement/pages/scopes/useScopes";
import { useServices } from "../../../modules/towermanagement/pages/services/useServices";
import { useSites } from "../../../modules/towermanagement/pages/sites/useSites";
import { useStatuses } from "../../../modules/towermanagement/pages/statuses/useStatuses";
import { useTeams } from "../../../modules/towermanagement/pages/teams/useTeams";
import { useCustomerRequesters } from "@/modules/towermanagement/pages/customerRequesters/useCustomerRequesters";
import { useHome } from "@/modules/towermanagement/pages/home/useHome";
import { useActivities } from "@/modules/towermanagement/pages/activities/useActivities";
import { useOrigins } from "../../../modules/towermanagement/pages/origins/useOrigins";
import { useApiKeys } from "@/modules/global/pages/apikeys/useApiKeys";
import { usePricingPlans } from "../../../modules/towermanagement/pages/pricingPlans/usePricingPlan";
import { usePricingValues } from "../../../modules/towermanagement/pages/pricingPlans/values/usePricingValues";
import { useContracts } from "../../../modules/towermanagement/pages/contracts/useContracts";
import { useContractValues } from "../../../modules/towermanagement/pages/contracts/values/useContractValues";
import { useItems } from "../../../modules/towermanagement/pages/items/useItems";
import { useAccessRequests } from "@/modules/towermanagement/pages/accessRequests/useAccessRequests";
import { useEquipmentCategories } from "@/modules/towermanagement/pages/equipmentCategories/useEquipmentCategories";
import { useForms } from "@/modules/towermanagement/pages/forms/form/useForms";

import { EModule, ESchema, EEntity } from "./tableEnums";

export { EModule, ESchema, EEntity };

export const useTables = {
  [EEntity.TWM_ACTIVITIES]: useActivities,
  [EEntity.FIN_HOME]: useHome,
  [EEntity.TWM_CUSTOMERS]: useCustomers,
  [EEntity.GBL_USERS]: useUsers,
  [EEntity.TWM_SERVICES]: useServices,
  [EEntity.TWM_TEAMS]: useTeams,
  [EEntity.GBL_APIKEYS]: useApiKeys,
  [EEntity.TWM_ORIGINS]: useOrigins,
  [EEntity.TWM_STATUSES]: useStatuses,
  [EEntity.TWM_SITES]: useSites,
  [EEntity.TWM_SCOPES]: useScopes,
  [EEntity.TWM_REASONS]: useReasons,
  [EEntity.TWM_OCCURRENCETYPES]: useOccurrenceTypes,
  [EEntity.TWM_PLANNINGSMAINTENANCES]: usePlanningsMaintenances,
  [EEntity.TWM_OUTSOURCEDES]: useOutsourcedes,
  [EEntity.TWM_REGIONS]: useRegions,
  [EEntity.TWM_APPROVALFLOWEXECUTIONSTEPS]: useApprovalFlowExecutionSteps,
  [EEntity.FIN_CUSTOMERSSUPPLIERS]: useCustomersSuppliers,
  [EEntity.TWM_APPROVALFLOWSTEPS]: useApprovalFlowSteps,
  [EEntity.TWM_SLAS]: useSLAs,
  [EEntity.TWM_CUSTOMER_REQUESTERS]: useCustomerRequesters,
  [EEntity.TWM_PRICINGPLANS]: usePricingPlans,
  [EEntity.TWM_PRICINGVALUES]: usePricingValues,
  [EEntity.TWM_CONTRACTS]: useContracts,
  [EEntity.TWM_CONTRACTVALUES]: useContractValues,
  [EEntity.TWM_ITEMS]: useItems,
  [EEntity.TWM_ACCESS_REQUESTS]: useAccessRequests,
  [EEntity.TWM_CATEGORYEQUIPMENT]: useEquipmentCategories,
  [EEntity.TWM_FORMS]: useForms,
};
